import { chakra, Box } from '@stockx/ui';

export const CategoriesContainer = chakra(Box, {
  baseStyle: {
    maxH: '680px',
    overflowY: 'scroll',
    overscrollBehavior: 'contain',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  label: 'CategoriesContainer',
});
